var _path, _path2;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
var SvgDsServiceAccountsIcon = function SvgDsServiceAccountsIcon(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 16,
    height: 16,
    fill: "none",
    viewBox: "0 0 16 16"
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    fill: "currentColor",
    d: "M10.471 3.805a.667.667 0 0 1-.942 0l-.862-.862v2.39a.667.667 0 0 1-1.334 0v-2.39l-.862.862a.667.667 0 1 1-.942-.943l2-2c.26-.26.682-.26.942 0l2 2c.26.26.26.682 0 .943M12.24 8.821a.667.667 0 1 0 .854 1.024l2-1.666a.667.667 0 0 0 0-1.025l-2-1.666a.667.667 0 0 0-.854 1.024l.585.488H10a.667.667 0 0 0 0 1.333h2.825z"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    fill: "currentColor",
    fillRule: "evenodd",
    d: "M3.846 5.573a.667.667 0 0 1-.086.94L3.175 7h4.158c.737 0 1.334.597 1.334 1.333v1.751a2.668 2.668 0 1 1-1.334 0v-1.75H3.175l.585.487a.667.667 0 0 1-.853 1.024l-2-1.666a.667.667 0 0 1 0-1.025l2-1.666a.667.667 0 0 1 .938.085M8 11.333A1.333 1.333 0 1 0 8 14a1.333 1.333 0 0 0 0-2.667",
    clipRule: "evenodd"
  })));
};
export default SvgDsServiceAccountsIcon;